import React from "react";

// Styles
import styles from "./style.module.scss";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean, field?: string) => void;
  field?: string;
  label?: string | React.ReactNode;
  className?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, field, label, className }) => {
  // Handlers
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (field) onChange(e.target.checked, field);
    else onChange(e.target.checked);
  };

  return (
    <label className={`${styles.toggleSwitch} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        role="switch"
        aria-checked={checked}
        tabIndex={0}
      />
      <span className={styles.toggleSwitch_slider} />
      {label && label}
    </label>
  );
}

export default ToggleSwitch;
